import { SurveyV2 } from '@act/shared/data-transfer-objects';
import RadioGroupInput from './RadioGroupInput';
import CheckboxInput from './CheckboxInput';
import SelectInput from './SelectInput';
import TextInput from './TextInput';
import DateInput from './DateInput';
import { Control } from 'react-hook-form';
import { DateTime } from 'luxon';

export interface SurveyInputMockProps {
  question: SurveyV2.CreateQuestionJSONDto;
  control: Control<{ value: string | number[] }>;
  name: string;
  togglePrompt: (prompt: SurveyV2.CreatePromptJSONDto) => void;
}

const SurveyInputMock = ({
  question,
  control,
  name,
  togglePrompt,
}: SurveyInputMockProps) => {
  const isRequired = question.validationConfiguration?.isRequired || true;

  if (question.type === 'checkbox') {
    // TODO: FIX CHECKBOXES - multi-inputs
    return (
      <CheckboxInput
        control={control as unknown as Control<{ [key: string]: number }>}
        options={question.options}
        isRequired={isRequired}
      />
    );
  }
  if (question.type === 'date') {
    const { maxDateOffset, minDateOffset } = question.validationConfiguration;
    const minDate =
      minDateOffset !== undefined
        ? DateTime.now().plus({ days: minDateOffset })
        : undefined;
    const maxDate =
      maxDateOffset !== undefined
        ? DateTime.now().plus({ days: maxDateOffset })
        : undefined;
    return (
      <DateInput
        control={control as unknown as Control<{ [key: string]: string }>}
        name={name}
        isRequired={isRequired}
        minDate={minDate}
        maxDate={maxDate}
      />
    );
  }
  if (question.type === 'multiselect' || question.type === 'select') {
    // TODO: FIX SELECTS - multi-inputs
    return (
      <SelectInput
        control={control as unknown as Control<{ [key: string]: string }>}
        name={name}
        options={question.options}
        togglePrompt={togglePrompt}
        isMultiple={question.type === 'multiselect'}
        isRequired={isRequired}
      />
    );
  }
  if (question.type === 'radio') {
    return (
      <RadioGroupInput
        control={control as unknown as Control<{ [key: string]: string }>}
        name={name}
        options={question.options}
        togglePrompt={togglePrompt}
        isRequired={isRequired}
      />
    );
  }
  return (
    <TextInput
      control={control as unknown as Control<{ [key: string]: string }>}
      name={name}
      isRequired={isRequired}
      isMultiline={question.type === 'textarea'}
    />
  );
};

export default SurveyInputMock;
